angular.module('CaresApp').factory('PersonaApplicableToService', function($resource) {
  return $resource('api/personaApplicableTo', {
  }, {
  });
});
